import UserApi from '@apis/user/UserApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const userQueries = createQueryKeys('user', {
  detail: () => ({
    queryKey: ['userDetail'],
    queryFn: () => UserApi.getUserDetail(),
  }),
  profile: () => ({
    queryKey: ['userProfile'],
    queryFn: () => UserApi.getUserProfile(),
  }),
  assets: () => ({
    queryKey: ['assets'],
    queryFn: () => UserApi.getAssets(),
  }),
});

export default userQueries;
